<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm4"></a></p>
<div class="fmhT"><b>Prologue</b></div>
<div class="fmtx1">&amp;</div>
<div class="fmtx1"><span class="dropcap"><b>T</b></span>he night they had come to perform their holy deed was very still.</div>
<div class="fmtx">Afterwards it occurred to the one whose name was Farid, the
youngest of the four men, that even the dogs had not made any
sound. The men were enveloped by the warm air and barely noticed the
faint breezes occasionally wafting in from the desert. They had been
waiting since the onset of darkness.</div>
<div class="fmtx">The car that had transported them on the long journey from Algiers
and the meeting place at Dar Aziza was old and had bad shocks. They
had been forced to interrupt their journey twice, the first time to repair
a flat on the left rear tire. They had not even traveled halfway at that
point. Farid, who had never before ventured beyond the capital, had sat
in the shadow of a boulder and gazed in wonderment at the dramatic
shifts in the landscape. The tire’s rubber surface was cracked and worn,
and it had blown out slightly north of Bou Saâda. It had taken a long
time to unscrew the old nuts and attach the spare. Farid had understood
from the muffled exchanges of the others that this delay meant
that they would not have time to stop to eat. The journey was finally
resumed. Then, shortly outside El Oued, the engine failed. Only after
an hour were they able to locate the problem and find a temporary solution.
Their leader, a pale man in his thirties with dark hair and the kind
of burning eyes found only among those who lived with the call of the
Prophet, angrily chided the chauffeur as he bent over the hot engine.
Farid did not know the leader’s name, who he was, or where he was
from. It was a measure of precaution.</div>
<div class="fmtx">Neither did he know the names of the other two men.</div>
<div class="fmtx">He only knew his own.</div>
<div class="fmtx">Eventually, they continued, the darkness already upon them, and
had only water to drink. Nothing to eat.</div>
<div class="fmtx">When they finally reached El Oued, the night was, as mentioned, very
still. They had stopped somewhere deep inside the town’s labyrinth of
streets, close to a market. As soon as they stepped outside, the car disappeared.
Somewhere out of the shadows a fifth man appeared and guided
them on. It was only then, as they hurried through the darkness on unknown
streets, that Farid began to think in earnest about what would
soon take place. With his hand he could feel the slightly curved blade of
the knife that rested in a case deep inside the pockets of his caftan.</div>
<div class="fmtx">It had been his brother, Rachid Ben Mehidi, who had first spoken to
him of foreigners. They had spent a warm night sitting on the roof of
their father’s house, looking out over the glimmering lights of Algiers.
Even back then, Farid had known that Rachid was deeply involved in the
struggle to change their country into an Islamic state, one that would
follow only those laws prescribed by the Prophet. Now he spoke with
Farid every evening about the importance of expelling the foreigners
from their land. At first Farid had felt flattered that his brother took the
time to discuss politics with him, even if at first he did not understand
everything Rachid said. It was only later that he realized that Rachid
had had another reason for devoting so much time to him. He wanted
Farid himself to be part of the fight to drive the foreigners out of the
land.</div>
<div class="fmtx">All this had taken place over a year ago. And now, as Farid followed
the black-clothed men through the dark and narrow alleyways where
the night air was completely stagnant, he was on his way to fulfilling
Rachid’s request. Foreigners had to be expelled. But they would not be
escorted to the harbors or airports. They would be killed. Then those
who had not yet come to this land would decide to stay where they were.</div>
<div class="fmtx"><i>Your task is holy,</i> Rachid had repeatedly told him. <i>The Prophet will be
pleased. Your future will be very bright once we have transformed this country
according to his wishes.</i></div>
<div class="fmtx">Farid fingered the knife in his pocket. Rachid had given it to him the night before, 
when they had said goodbye to each other on the roof. It had a beautiful ivory shaft.</div>
<div class="fmtx">They stopped when they reached the outskirts of the town. The
streets opened onto a plaza. The night sky above them was very clear.
They stood in the shadow of a long building with stucco walls, roller
blinds shuttering its row of closed shops. On the other side of the street
was a large stone villa behind an iron fence. The man who had led them
here disappeared without a sound. Again they were only four. Everything
was very quiet. Farid had never experienced anything like it before.
It had never been so quiet in Algiers. In the nineteen years he had
lived up to this moment he had never found himself in such stillness as
he experienced now.</div>
<div class="fmtx">Not even the dogs, he thought. I can’t even hear the dogs that are out
there in this darkness.</div>
<div class="fmtx">Lights were on in a few of the windows of the villa across the street. A
bus with broken, flickering headlights came clattering down the street.
Then silence fell again.</div>
<div class="fmtx">One of the lit windows went black. Farid tried to guess the time. They
had been waiting perhaps half an hour. He was very hungry, having had
nothing to eat since the early morning. The two flasks of water they had
brought with them were also gone. But he did not want to ask for anything
more. It would infuriate their leader. They were there to carry out
a holy order and he asked for water?</div>
<div class="fmtx">Yet another light went off, and then, very shortly, the last one. The
villa on the other side of the street was now dark. They continued to
wait. Then their leader made a sign and they hastened across the street.
An old guard posted at the gate was sleeping. He had a wooden stick
in his hand. The leader gave him a kick. When the guard awoke, Farid
saw the leader hold a knife close to his face and whisper something in
his ear. Even in the poor light of the streetlamp Farid could see the fear
in the old man’s eyes. The guard stood up and limped away. The gate
creaked faintly as they opened it and slipped into the garden. There
was a strong scent of jasmine and an herb that Farid recognized but
could not remember the name of. Everything was still very quiet. Next
to the tall doors of the house was a sign that read “Order of the Sisters
of Christ.” Farid tried to think about what this could mean. At the same
moment he felt a hand on his shoulder. He jumped. It was the leader
who had touched him. For the first time he spoke—so softly that not
even the night wind could hear what was said.</div>
<div class="fmtx">“There are four of us,” he said. “Inside there are also four people.
They are sleeping one by one in separate rooms on either side of a corridor.
They are old and will not offer any resistance.”</div>
<div class="fmtx">Farid looked at the other two men at his side. They were a couple of
years older than he was. All at once Farid was sure they had done something
like this before. He was the only one who was new. But he did not
feel any anxiety. Rachid had assured him that what he was doing was for
the sake of the Prophet.</div>
<div class="fmtx">The leader glanced at him, as if reading his thoughts.</div>
<div class="fmtx">“Four women live in this house,” he said. “They are foreigners who
have refused to leave our land willingly. Therefore they have chosen to
die. In addition, they are Christian.”</div>
<div class="fmtx">I am going to kill a woman, Farid thought. Rachid had not said anything
about this.</div>
<div class="fmtx">There could be only one reason for it.</div>
<div class="fmtx">It was of no significance. It made no difference.</div>
<div class="fmtx">Then they entered the house. The front door had a lock that was
easy to force with the blade of a knife. Inside, where it was dark and
very warm since there was no breeze, they turned on their flashlights
and carefully made their way up the wide staircase that wound its way
up through the house. In the upstairs corridor there was a single bulb
in the ceiling. All was still. There were four closed doors before them.
The men unsheathed their knives. The leader pointed to the doors and
nodded. Farid knew there was no room for hesitation. Rachid had said
that everything had to be done very quickly. He would avoid looking at
the eyes. He would look only at the throat and then make his cut firmly
and decisively.</div>
<div><br/></div>
<div class="fmtx1">Afterwards he could not remember much of what had happened. The
woman lying in the bed with a white sheet pulled over her had possibly
had gray hair. He saw only a dim outline since very little light came in
from the street. At the moment he had pulled the sheet away, she had
woken up. But she had no time to scream, no time to understand what
was happening, before he slashed her throat and immediately stepped
back in order to avoid the blood. Then he had turned around and returned
to the corridor. The whole thing had taken less than half a minute.
Somewhere inside him the seconds had ticked by. They were just
about to leave when one of the men called out in a low voice. The leader
stiffened for a moment as if he didn’t know what to do.</div>
<div class="fmtx">There was another woman in one of the rooms. A fifth woman.</div>
<div class="fmtx">She should not have been there. She was a stranger. Perhaps she was
visiting.</div>
<div class="fmtx">But she was also a foreigner. That much was apparent to the man who
had discovered her.</div>
<div class="fmtx">The leader entered the room. Farid, who was standing behind him,
could see that the woman had curled up on the bed. Her fear filled him
with nausea. There was a dead body in the bed across from her. The
white sheet was drenched with blood.</div>
<div class="fmtx">The leader pulled out his knife and slit the throat of the fifth woman.</div>
<div class="fmtx">Afterwards they left the house as silently as they had come. Somewhere
in the darkness, the car was waiting for them. When dawn arrived,
they had already left El Oued and the corpses of the five women
far behind.</div>
<div class="fmtx">It was May 1993.</div>
<div><br/></div>
<div class="fmtx1">The letter arrived in Ystad on August 19th, 1993.</div>
<div class="fmtx">Since it had an African stamp and must be from her mother, she waited to open it. She wanted to have peace and quiet when she read
it. From the thickness of the envelope she could tell there were many
pages. She hadn’t heard a word from her mother in over three months;
surely she must have plenty of news by now. She left the letter lying on
the coffee table and decided to wait until evening. But she felt vaguely
uneasy. Why had her mother typed her name and address this time? No
doubt the answer would be in the letter. It was close to midnight by the
time she opened the door to the balcony and sat down in her easy chair,
which was squeezed in among all her flowerpots. It was a lovely, warm
August evening. Maybe one of the last of the year. Autumn was already
at hand, hovering unseen. She opened the letter and started to read.</div>
<div class="fmtx"><br/></div>
<div class="fmtx1">Only afterwards, when she had read the letter to the end and put it
aside, did she start to cry.</div>
<div class="fmtx">By that time, she also knew that the letter was written by a woman.
The style of the handwriting was not her first clue. There was also something
about the choice of words, how the unknown woman tentatively
and cautiously approached the task of describing as mercifully as possible
all the gruesome events that had occurred.</div>
<div class="fmtx">But there was no mercy involved. There was only the act itself. That
was all.</div>
<div class="fmtx">The letter was signed by Françoise Bertrand, a police officer. Her
position was not entirely clear, but apparently she was employed as a
criminal investigator for the country’s central homicide commission. It
was in this capacity that she had learned of the events that took place
one night in May in a remote desert town.</div>
<div class="fmtx">Outwardly the facts of the case were clear, easy to grasp, and utterly
terrifying. Four nuns, French citizens, had been slaughtered by unknown
assailants. The women’s throats had been cut. The perpetrators
had left no traces, only blood; thick, congealed blood everywhere.</div>
<div class="fmtx">But there had also been a fifth woman, a Swedish tourist, who had renewed
her residence permit in the country several times and happened
to be visiting the nuns on the night the assailants appeared with their
knives. Her passport, found in a handbag, revealed that her name was
Anna Ander, sixty-six years old, in the country on a legal tourist visa.
There was also an open-return plane ticket. Since it was bad enough that
four nuns had been murdered, and since Anna Ander seemed to have
been traveling alone, the detectives on the case, in response to political
pressure, decided not to mention the fifth woman. She was simply not
there on that fateful night. Her bed was empty. Instead, they reported
her death in a traffic accident and then buried her, nameless and unknown,
in an unmarked grave. All her belongings were discarded,
all traces of her erased. And it was here that Françoise Bertrand entered
the picture. <i>Early one morning I was called in by my boss, she wrote in the
long letter, and ordered to drive out to the scene at once.</i> By this time the
woman was already buried. Françoise Bertrand’s job was to get rid of
any last traces of her and then destroy her passport and other effects.</div>
<div class="fmtx">Anna Ander had supposedly never arrived or spent any time in the
country. She had ceased to exist, obliterated from all official records.
But Françoise Bertrand discovered a travel bag that the sloppy homicide
investigators had overlooked. It was lying behind a wardrobe. Or
maybe it had been on top and then fallen off, she couldn’t tell. But there
were letters in it that Anna Ander had begun to write, and they were
addressed to her daughter in a town called Ystad in faraway Sweden.
Françoise Bertrand apologized for reading these private papers. She
had asked for help from a drunken Swedish artist she knew in the capital,
and he had translated the letters for her without knowing anything
about the case. Françoise wrote down the translations as he read, and a
picture gradually began to take shape.</div>
<div class="fmtx">Even then she already had serious pangs of conscience about what
had happened to this fifth woman. Not only about the fact that she was
murdered so ruthlessly in the country that Françoise loved so much but
which was so torn by internal strife. In the letter, she tried to explain
what was happening in her country, and she also told something about
herself. Her father was born in France but came to Africa as a child with
his parents. There he grew up, and later married a local woman. Françoise,
the oldest of their children, had always had the feeling of having
one foot in France and the other in Africa. But now she no longer had
any doubt. She was an African. And that was why she was so tormented
by the antagonisms tearing her country apart. That was also why she
didn’t want to contribute to the wrongs against herself and her country
by erasing this woman, by drowning the truth in a fabricated car crash,
refusing even to take the responsibility for Anna Ander’s presence.
Françoise Bertrand had begun to suffer from insomnia, she wrote. Finally
she decided to write to the dead woman’s daughter and tell her
the truth. She forced herself to act in spite of the loyalty she felt to the
police force. But she asked that her name be kept secret. <i>I’m writing you
the truth</i>, she concluded her long letter. <i>Maybe I’m making a mistake by telling
you what happened. But how could I do otherwise? I found a bag containing
letters that a woman wrote to her daughter. Now I’m telling you how they came
into my possession and forwarding them to you.</i></div>
<div class="fmtx">Françoise Bertrand had enclosed the unfinished letters in the
envelope.</div>
<div class="fmtx">Along with Anna Ander’s passport.</div>
<div class="fmtx">Her daughter didn’t read the letters. She put them on the floor of the balcony and wept for a long time. Not until dawn did she get up and
go into the kitchen. She sat motionless at the kitchen table for quite a
while. Her head was completely empty. But then she started to think,
and suddenly everything seemed simple to her. She realized that she
had done nothing but wait all these years. She hadn’t understood that
before: the fact that she had been waiting, or why. Now she knew. She
had a mission, and she didn’t need to wait any longer to carry it out. It
was time. Her mother was gone. A door had been thrown wide open.</div>
<div class="fmtx">She stood up and went to get her box with the slips of paper she had
cut up, and the big ledger she kept in a drawer under her bed. She
spread the folded slips of paper on the table in front of her. She knew
there were exactly forty-three of them. One of them had a black cross. Then she started unfolding the slips, one by one.</div>
<div class="fmtx">The cross was on the twenty-seventh one. She opened the ledger and
ran her finger down the column of names until she reached the twenty-seventh
row. She stared at the name she had written there and slowly
saw a face materialize in her mind.</div>
<div class="fmtx">Then she closed the book and put the slips of paper back in the box.</div>
<div class="fmtx">Her mother was dead.</div>
<div class="fmtx">She no longer had any doubt. And now there was no turning back.
She would give herself a year to work out the grief, to make all her
preparations.</div>
<div class="fmtx">Once more she went out on the balcony. She smoked a cigarette and
gazed out over the waking city. A rainstorm was moving in from the sea.</div>
<div class="fmtx">Just after seven she went to bed.</div>
<div class="fmtx">It was the morning of August 20th, 1993.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// henn_9781595586124_oeb_fm4_r1.vue?02017760